if (!window.Eurus.loadedScript.has('pagination.js')) {
  window.Eurus.loadedScript.add('pagination.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      // fiveaven : pages suivantes chargées en ne demandant QUE la section de la grille (rendu de section Shopify,
      // ~190 Ko au lieu de ~900 Ko pour la page entière) et préchargées d'avance : au bas de la grille, la suite est déjà là.
      // fiveaven : une page qui échoue ne reste pas en cache (sinon elle ne se rechargerait jamais) ; une page affichée en sort aussi
      const cache = new Map();
      const avecSection = (url, sectionId) => url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
      const charger = (url, sectionId) => {
        if (!cache.has(url)) {
          const promesse = fetch(avecSection(url, sectionId))
            .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
            .then((t) => (t.indexOf('id="items-grid"') > -1 ? t : Promise.reject('grille absente')))
            .catch(() => fetch(url).then((r) => (r.ok ? r.text() : Promise.reject(r.status)))); // repli : page entière, comme avant
          promesse.catch(() => { if (cache.get(url) === promesse) cache.delete(url); });
          cache.set(url, promesse);
        }
        return cache.get(url);
      };
      const suivante = (racine) => {
        const m = racine && racine.innerHTML.match(/loadData\('([^']+)'\)/);
        return m ? m[1].replace(/&amp;/g, '&') : null;
      };
      // fiveaven : défilement vraiment infini, sans bouton (consigne d'Andy du 17/10/2026) : une page qui échoue est redemandée
      // sans rien afficher après 1 s, 3 s puis 8 s ; si elle échoue encore, le prochain geste vers le bas relance le chargement
      const PAUSES = [1000, 3000, 8000];
      const attendre = (ms) => new Promise((r) => setTimeout(r, ms));
      // infini = true : défilement infini (snippets/pagination) ; absent : bouton « Charger plus » au clic, inchangé
      Alpine.data("xPagination", (sectionId, infini) => {
        let desarmer = () => {};
        return {
          loading: false,
          init() {
            // précharge la page 2 dès que la page est calme
            const lancer = () => { const u = suivante(document.getElementById(`btn-pagination-${sectionId}`)); if (u) charger(u, sectionId); };
            if ('requestIdleCallback' in window) requestIdleCallback(lancer, { timeout: 2500 }); else setTimeout(lancer, 1500);
          },
          async loadData(url) {
            if (this.loading) return; // un seul chargement à la fois (repère du bas + relance)
            const racine = document.getElementById(`btn-pagination-${sectionId}`);
            this.loading = true;
            desarmer();
            try {
              let html = null, target = null, productGrid = null;
              for (let essai = 0; ; essai++) {
                try {
                  const text = await charger(url, sectionId);
                  html = new DOMParser().parseFromString(text, 'text/html');
                  productGrid = html.getElementById('items-grid');
                  target = document.getElementById('blog-grid') || document.getElementById('items-grid');
                  if (!productGrid || !target) throw new Error('grille absente');
                  break;
                } catch (e) {
                  cache.delete(url); // jamais d'échec en cache : chaque tentative redemande la page
                  if (essai >= PAUSES.length) throw e;
                  await attendre(PAUSES[essai]);
                  if (racine && !racine.isConnected) return; // grille remplacée entre-temps (filtres) : on abandonne
                }
              }
              if (racine && !racine.isConnected) return;
              const newProducts = Array.from(productGrid.querySelectorAll('.grid-item'));
              // fiveaven : produits ajoutés d'un coup ; chacun « pop » en entrant à l'écran (assets/fv-pop.js)
              newProducts.forEach((item) => target.appendChild(item));
              cache.delete(url); // page affichée : plus besoin de la garder
              this._renderButton(html);
              const apres = suivante(html.getElementById(`btn-pagination-${sectionId}`));
              if (apres) charger(apres, sectionId);
            } catch (e) {
              console.error(e);
              if (infini) this._rearmer(url, racine);
            } finally {
              this.loading = false;
            }
          },
          // tentatives épuisées : le déclencheur se réarme, le prochain geste vers le bas (défilement, molette, doigt) relance
          _rearmer(url, racine) {
            desarmer();
            let dernier = window.scrollY, departDoigt = null;
            const relancer = () => { desarmer(); if (!racine || racine.isConnected) this.loadData(url); };
            const surDefilement = () => { const y = window.scrollY; if (y > dernier + 2) relancer(); else dernier = y; };
            const surMolette = (e) => { if (e.deltaY > 0) relancer(); };
            const surDoigt = (e) => { const t = e.touches && e.touches[0]; if (!t) return; if (departDoigt == null) departDoigt = t.clientY; else if (departDoigt - t.clientY > 10) relancer(); };
            const finDoigt = () => { departDoigt = null; };
            const evts = [['scroll', surDefilement], ['wheel', surMolette], ['touchmove', surDoigt], ['touchend', finDoigt]];
            evts.forEach(([n, f]) => window.addEventListener(n, f, { passive: true }));
            desarmer = () => { evts.forEach(([n, f]) => window.removeEventListener(n, f)); desarmer = () => {}; };
          },
          _renderButton(html) {
            const destination = document.getElementById(`btn-pagination-${sectionId}`);
            const source = html.getElementById(`btn-pagination-${sectionId}`);
            if (destination && source) {
              destination.innerHTML = source.innerHTML;
            }
          }
        };
      });
    });
  });
}
